import React from "react";
import { IonItem, IonLabel, IonIcon } from "@ionic/react";
import usePreciario from "../../hooks/usePreciario";
import { informationCircle } from "ionicons/icons";

const ConceptoMobile = ({ concepto, extra }) => {
  const { showConceptoDetail } = usePreciario();
  return (
    <IonItem
      className="custom-ionitem"
      style={extra ? { "--background": "rgba(220,53,69,0.05)" } : undefined}
    >
      <IonLabel>
        <span className="small">{"["}{concepto.clave}{"]"} {concepto.nombre}</span>
      </IonLabel>
      <IonIcon
        onClick={() => showConceptoDetail(concepto)}
        icon={informationCircle}
        color={extra ? "danger" : "primary"}
        slot="end"
      />
    </IonItem>
  );
};

export default ConceptoMobile;
